import { Injectable, Injector } from '@angular/core';

import { RpcError } from './rpc.error';
import { AuthenticationService } from '../../authentication/authentication.service';
import { ModalService } from '../components/modal/modal.service';
import { MessageModalComponent } from '../components/modal/message-modal/message-modal.component';
import { RestError } from './rest.error';

@Injectable()
export class ErrorLogService {
  constructor(private injector: Injector, private modal: ModalService) {}

  public get auth(): AuthenticationService {
    return this.injector.get(AuthenticationService);
  }

  public logError(error: any): void {
    if (error) {
      if (error.code === 1001 || error.type === 'RPC_ERROR') {
        this.handleRpcError(error);
      } else if (error.code === 401 || error.type === 'REST_ERROR') {
        this.handleRestError(error);
      } else {
        this.sendToConsole(error);
      }
    }
  }

  private sendToConsole(error: any): void {
    if (console && console.group && console.error) {
      console.group('Error Log Service');
      console.error(error);
      console.groupEnd();
    }
  }

  private handleRpcError(error: RpcError): void {
    let errorIsHandled = false;

    if (error && error.code === 1001) {
      if (error.permissionDeniedType === 'NOT_AUTHENTICATED') {
        errorIsHandled = true;
        this.auth.logout();
      }
    }

    if (error && error.code > 10000 && !errorIsHandled) {
      this.modal.open(MessageModalComponent, {
        title: 'Error',
        message: error.detailMessage
      });
    } else if (error.code <= 10000 && !errorIsHandled) {
      // Error code 10.000 does not exist.
      this.modal.open(MessageModalComponent, {
        title: 'Something went wrong',
        message: 'Something unexpected happened. Please try again.'
      });
    }
  }

  private handleRestError(error: RestError): void {
    switch (error.code) {
      case 500:
      case 400:
        this.modal.open(MessageModalComponent, {
          title: 'Error',
          message: error.message
        });
        break;
      case 401:
        this.auth.logout();
        break;
      case 403:
        this.modal.open(MessageModalComponent, {
          title: 'Not allowed',
          message: error.message
        });
        break;
      case 404:
        this.modal.open(MessageModalComponent, {
          title: 'Not found',
          message: error.message
        });
        break;
      case 504:
        this.modal.open(MessageModalComponent, {
          title: 'Server timeout',
          message: error.message
        });
        break;
      default:
        this.modal.open(MessageModalComponent, {
          title: 'Something went wrong',
          message: 'Something unexpected happened. Please try again.'
        });
        break;
    }
  }
}
